import React, { useState } from "react";
import { loginUser } from "../../api/auth"; // Pastikan Anda memiliki fungsi loginUser di api/auth.js

const LoginForm = () => {
  const [form, setForm] = useState({ identifier: "", password: "" });
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMsg("");

    try {
      const data = await loginUser(form);
      setSuccessMsg(`Selamat datang kembali, ${data.user.username}`);
      // Simpan JWT jika perlu
      localStorage.setItem("token", data.jwt);
    } catch (err) {
      setError(err.message || "Terjadi kesalahan saat login");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "auto" }}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="identifier"
          placeholder="Username atau Email"
          value={form.identifier}
          onChange={handleChange}
          required
        /><br /><br />
        <input
          type="password"
          name="password"
          placeholder="Kata sandi"
          value={form.password}
          onChange={handleChange}
          required
        /><br /><br />
        <button type="submit">Login</button>
      </form>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {successMsg && <p style={{ color: "green" }}>{successMsg}</p>}
    </div>
  );
};

export default LoginForm;